import React from 'react'
import { Mail, FileDown } from 'lucide-react'
import { FaRegFilePdf } from "react-icons/fa";

function DownloadModal_MA_BUS(props) {
    const { handleDownload, handleEmailClick } = props

    return (
        <div>
            <div>
                <div className="modal-body px-3" style={{ overflowY: "scroll", height: "200px", }}>
                    <div className='d-flex justify-content-between mb-3 align-items-center' >
                        <div><FaRegFilePdf size={50} color='red' /> Download to device</div>
                        <button onClick={() => handleDownload()} className='w-25 h-25  btn ms_btn_ace' data-dismiss={"modal"}>Download</button>
                    </div>
                    <br />
                    <div className='d-flex justify-content-between align-items-center'>
                        <div><Mail size={50} color="#83a4cf" /> Send to registered Email address</div>
                        <button onClick={() => handleEmailClick()} className='w-25 h-25 btn ms_btn_ace' data-dismiss={"modal"}>Send Email</button>
                    </div>

                </div>
            </div >
        </div >
    )
}

export default DownloadModal_MA_BUS
